import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 3.9.",
  "description": "",
  "published": "2011-09-03T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-3-9/swizec/2351"],
  "categories": "Claude Shannon, Information theory, Learning, Math, Personal, Probability and statistics, Study skills",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Studying.jpg",
        "alt": "A Student of the University of British Columbi...",
        "title": "A Student of the University of British Columbi..."
      }}></img></p>
    <p>{`Apparently I have neglected to learn anything the past two days. Most likely because I've been a bit swamped with a particular `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Probability_and_statistics",
        "title": "Probability and statistics"
      }}>{`probability and statistics`}</a>{` theory exam that I started `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Study_skills",
        "title": "Study skills"
      }}>{`studying`}</a>{` for much too late and ended up having only a day and a half time to learn 300 pages of ... stuff ... by heart.`}</p>
    <p>{`I guess the main lesson of the past couple of days has been that I `}<em parentName="p">{`suck`}</em>{` at studying and should really make an attempt to plan these things better. But the thing is that slow studying where people study for a couple of hours a day and do this for two weeks ... it just doesn't work for me. I get distracted and lose the appropriate mindset for a specific topic.`}</p>
    <p>{`Specifically today I learned that some textbooks are superbly lame for studying from. You know that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-30-8/swizec/2308",
        "title": "I learned two things today 30.8."
      }}>{`statics textbook`}</a>{` I laughed at a couple of days ago?`}</p>
    <p>{`It's a brilliant piece of study material. Just gorgeous compared to what a certain professor managed to come up with for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Information_theory",
        "title": "Information theory"
      }}>{`information theory`}</a>{`. The whole thing is barely twice as long as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Claude_Shannon",
        "title": "Claude Shannon"
      }}>{`Shannon's`}</a>{` original article on the topic ... most of the difference is due to different text setting and that a couple of formulae have rigorous proofs written down.`}</p>
    <p>{`Most of the textbook is just pages upon pages of formulae and proofs, without any real context given. Yay for good study materials!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/prweb2011/8/prweb8749837.htm"
        }}>{`Classroom or Beach? Best Study Locations Identified`}</a>{` (prweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://greenteapress.com/thinkstats/html/index.html"
        }}>{`Think Stats: Probability and Statistics for Programmers`}</a>{` (greenteapress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://socyberty.com/education/homeschooling-methods-2/"
        }}>{`Homeschooling Methods`}</a>{` (socyberty.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a1397f1a-b638-43c6-ba7c-3766672c0005",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      